/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MobileDeviceRegisterResponse
 */
export interface MobileDeviceRegisterResponse {
    /**
     * 
     * @type {string}
     * @memberof MobileDeviceRegisterResponse
     */
    deviceId: string;
}

/**
 * Check if a given object implements the MobileDeviceRegisterResponse interface.
 */
export function instanceOfMobileDeviceRegisterResponse(value: object): value is MobileDeviceRegisterResponse {
    if ((!('deviceId' in (value as Record<string, any>)) && !('device_id' in (value as Record<string, any>))) || ((value as Record<string, any>)['deviceId'] === undefined && (value as Record<string, any>)['device_id'] === undefined)) return false;
    return true;
}

export function MobileDeviceRegisterResponseFromJSON(json: any): MobileDeviceRegisterResponse {
    return MobileDeviceRegisterResponseFromJSONTyped(json, false);
}

export function MobileDeviceRegisterResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MobileDeviceRegisterResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'deviceId': json['device_id'],
    };
}

export function MobileDeviceRegisterResponseToJSON(json: any): MobileDeviceRegisterResponse {
    return MobileDeviceRegisterResponseToJSONTyped(json, false);
}

export function MobileDeviceRegisterResponseToJSONTyped(value?: MobileDeviceRegisterResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'device_id': value['deviceId'],
    };
}

